import { render, staticRenderFns } from "./ParlayInfoPremium.vue?vue&type=template&id=178b584e&scoped=true&"
import script from "./ParlayInfoPremium.vue?vue&type=script&lang=js&"
export * from "./ParlayInfoPremium.vue?vue&type=script&lang=js&"
import style0 from "./ParlayInfoPremium.vue?vue&type=style&index=0&id=178b584e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b584e",
  null
  
)

export default component.exports